import { GET_GLOBAL_DATA, RECALL_GLOBAL_DATA } from "../type";

export const getGlobalDataAction = (data) => ({ type: GET_GLOBAL_DATA, payload: data })
export const recallGlobalDataAction = () => ({ type: RECALL_GLOBAL_DATA })